var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"rooms-calendar"},[_c('RoomsCalendar',{attrs:{"center":_vm.center}})],1),_c('div',{staticClass:"rooms-list"},[_c('RoomsList',{attrs:{"rooms":_vm.filteredRooms}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }